import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../../queryKeys';

interface MutationVariables {
	templateId: string;
	step: Api.ITagAutomationStep;
	beforeId?: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepRemoveTagCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationStep, variables: MutationVariables) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ templateId, step, beforeId, impersonationContext }: MutationVariables) => {
			const queryParams = beforeId ? { beforeId } : undefined;
			return userSession.webServiceHelper.callAsync<Api.IAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/RemoveTag`,
					queryParams,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data, variables);
		},
	});
}
